const handleLocationSelected = async (event) => {
    const productId = document.querySelector("product-info").getAttribute("data-product-id");
    const selectedVariant = document.querySelector("product-info variant-selects").getAttribute("data-variant");
    const metafieldKey = event.detail.preorder_metafield_key;
    const buyButtons = document.querySelectorAll("product-info .product-form__buttons  button[type='submit']");
    if (!productId || !selectedVariant) {
        console.error("Product ID or selected variant not found.");
        return;
    }

    //show the loading spinner before the query is made
    buyButtons.forEach((button) => {
        button.setAttribute("aria-label", "Loading...");
        button.setAttribute("disabled", "true");
        button.querySelector('.loading__spinner').classList.remove('hidden');
    });
    
    const queryResult = await getVariantsWithMetafieldKey(productId, selectedVariant, metafieldKey);

    if (queryResult) {
        updateBuyButtons(queryResult);
    }
}

const getVariantsWithMetafieldKey = async (productId, variantId, key) => {
    const res = await window.yr.gql.getProductVariantsWithMetafield(`gid://shopify/Product/${productId}`, key, "custom", 50, variantId);
    const variants = res.data.product.variants.nodes;
    return variants;
}

const updateBuyButtons = (variants) => {
    for (let i = 0; i < variants.length; i++) {
        let variant = variants[i];
        let variantId = variant.id.split('gid://shopify/ProductVariant/')[1];
        let variantBuyButton = document.querySelector(`product-info button[type='submit'][data-variant="${variantId}"]`);
        let variantBuyButtonSpan = variantBuyButton.querySelector("span");
        if(!variantBuyButton) {
            console.error(`Buy button not found for variant ID: ${variantId}`);
            continue;
        }
        if(!!variant.metafield) {
            variantBuyButtonSpan.textContent = variant.metafield.value;
            variantBuyButton.querySelector('.loading__spinner').classList.add('hidden');
            variantBuyButton.setAttribute("aria-label", variant.metafield.value);
            variantBuyButton.removeAttribute("disabled");
        } else {
            variantBuyButton.querySelector('.loading__spinner').classList.add('hidden');
            variantBuyButtonSpan.textContent = "ADD TO CART";
            variantBuyButton.removeAttribute("disabled");
        }
    }
}

document.addEventListener("delivery_location_selected", handleLocationSelected, false);
